module.exports = __webpack_public_path__ + "static/media/no-order-illustration.8dd49171.svg";